import { equipTypes } from "@/const/equips/equipment";
interface MonsterType {
  id: number;
  name: string;
  props: any;
  growth: number; //每级成长系数
  drops: string[]; //掉落
  dropOdds: []; // 掉落材料
  coin: number[]; //金币奖励'
  mount: number;
  grade: number[]; // 各品级掉落几率
}
// grade[20, 50, 20, 10, 5, 0, 1, 0] 无 白 蓝 紫 粉 传说 史诗 神话
export const monsters: MonsterType[] = [
  {
    id: 0,
    name: "哥布林",
    props: {
      CHP: 20,
      ATK: 5,
      DEF: 10,
      AS: 1
    },
    growth: 1.1, //每级成长系数
    drops: [equipTypes.weapon, equipTypes.necklace, equipTypes.lorica], //掉落
    dropOdds: [], //
    coin: [1, 10], //金币奖励'
    mount: 1,
    grade: [20, 20, 20, 10, 3] // 各品级掉落几率
  },
  {
    id: 1,
    name: "精英哥布林",
    props: {
      CHP: 80,
      ATK: 20,
      DEF: 50,
      AS: 1
    },
    growth: 1.15, //每级成长系数
    drops: [equipTypes.weapon, equipTypes.necklace, equipTypes.lorica], //掉落
    dropOdds: [], //
    coin: [5, 50], //金币奖励'
    mount: 1,
    grade: [10, 20, 20, 10, 4] // 各品级掉落几率
  },
  {
    id: 2,
    name: "哥布林王-雷雷",
    props: {
      CHP: 220,
      ATK: 60,
      DEF: 120,
      AS: 1.5
    },
    growth: 1.2, //每级成长系数
    drops: [equipTypes.weapon, equipTypes.necklace, equipTypes.lorica], //掉落
    dropOdds: [], //
    coin: [10, 200], //金币奖励'
    mount: 2,
    grade: [1, 4, 4, 8, 8, 0, 1] // 各品级掉落几率
  },
  {
    id: 3,
    name: "史莱姆",
    props: {
      CHP: 30,
      ATK: 10,
      DEF: 20,
      AS: 1.1
    },
    growth: 1.1, //每级成长系数
    drops: [equipTypes.weapon, equipTypes.necklace, equipTypes.lorica], //掉落
    dropOdds: [], //
    coin: [1, 10], //金币奖励'
    mount: 1,
    grade: [20, 20, 20, 10, 3]
  },
  {
    id: 4,
    name: "猫妖",
    props: {
      CHP: 40,
      ATK: 15,
      DEF: 25,
      AS: 1.5
    },
    growth: 1.1, //每级成长系数
    drops: [equipTypes.weapon, equipTypes.necklace, equipTypes.lorica], //掉落
    dropOdds: [], //
    coin: [1, 10], //金币奖励'
    mount: 1,
    grade: [20, 20, 20, 10, 3]
  },
  {
    id: 5,
    name: "嗜血猫妖",
    props: {
      CHP: 100,
      ATK: 20,
      DEF: 60,
      AS: 1.4
    },
    growth: 1.1, //每级成长系数
    drops: [equipTypes.weapon, equipTypes.necklace, equipTypes.lorica], //掉落
    dropOdds: [], //
    coin: [2, 20], //金币奖励'
    mount: 1,
    grade: [10, 20, 20, 15, 4]
  },
  {
    id: 6,
    name: "猛毒猫妖",
    props: {
      CHP: 120,
      ATK: 30,
      DEF: 100,
      AS: 1.1
    },
    growth: 1.2, //每级成长系数
    drops: [equipTypes.weapon, equipTypes.necklace, equipTypes.lorica], //掉落
    dropOdds: [], //
    coin: [5, 50], //金币奖励'
    mount: 1,
    grade: [100, 200, 300, 100, 10, 0, 3]
  },
  {
    id: 7,
    name: "猫妖王-喵喵",
    props: {
      CHP: 250,
      ATK: 55,
      DEF: 150,
      AS: 1.8
    },
    growth: 1.2, //每级成长系数
    drops: [equipTypes.weapon, equipTypes.necklace, equipTypes.lorica], //掉落
    dropOdds: [], //
    coin: [10, 100], //金币奖励'
    mount: 2,
    grade: [50, 100, 100, 50, 10, 0, 9]
  }
];

export const monstersMap = new Map();
monsters.forEach(m => {
  monstersMap.set(m.id, m);
});
